import './shims/polyfills';
import 'raf/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';

import { BridgeProductManagementPage } from './bridgeproductmanagementpage';
import Product from './product/traitProduct';
import CabinetProduct from './product/cabinetProduct';
import ColorProduct from './product/colorProduct';
import SubmitQuotePage from './submitquotepage';
import { CheckoutComponent } from './checkout';
import WishlistsApp from './wishlists/WishlistsApp';
import { CheckoutNotes } from './checkout/Features/Notes/CheckoutNotes';

import './index.css';

global['React'] = React;
global['ReactDOM'] = ReactDOM;
global['ReactDOMServer'] = ReactDOMServer;

global['BridgeProductManagementPage'] = BridgeProductManagementPage;
global['Product'] = Product;
global['CabinetProduct'] = CabinetProduct;
global['SubmitQuotePage'] = SubmitQuotePage;
global['ColorProduct'] = ColorProduct;
global['Checkout'] = CheckoutComponent;
global['Wishlists'] = WishlistsApp;
global['UserNotes'] = CheckoutNotes;